// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","593":"fail"}[chunkId] + "." + {"443":"6fafac0d","593":"cb2d844e"}[chunkId] + ".js";
};